import { Invoice } from './Invoice';
import { Prepayment } from './Prepayment';

export class UnsettledReceivables {
  public unpaidInvoices: Invoice[];
  public prepayments: Prepayment[];
  public debtAmount: number;
  public totalAmountToPay: number;
}
